import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { ManualEdlinkSync } from '@/components/edlink/manual-edlink-sync';
import { ChevronDown } from 'lucide-react';
import { isAirAdmin, isCoach, isCoachRole, isEdgeCoach } from '@airreading/common';
import { ManageAirAdmin } from '@/routes/_layout/users/-components/manage-air-admin';
import { ManageEdgeCoach } from '@/routes/_layout/users/-components/manage-edge-coach';
import { PromoteCoach } from '@/routes/_layout/users/-components/promote-coach';
import { ManageCoach } from '@/routes/_layout/users/-components/manage-coach';
import { SingleUserFull, UserRoleStatus } from '@airreading/common/data';

interface ManagePermissionsDropdownProps {
  user: SingleUserFull;
}

export function ManagePermissionsDropdown({ user }: ManagePermissionsDropdownProps) {
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" icon={ChevronDown}>
          Manage permissions
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {isCoach(user) ? (
          <ManageCoach
            trigger={
              <DropdownMenuItem onSelect={(e) => e.preventDefault()}>
                {user.userRoles.some((role) => isCoachRole(role) && role.status === UserRoleStatus.active)
                  ? 'Revoke teacher role'
                  : 'Restore teacher role'}
              </DropdownMenuItem>
            }
            user={user}
          />
        ) : (
          <PromoteCoach
            trigger={<DropdownMenuItem onSelect={(e) => e.preventDefault()}>Promote as teacher</DropdownMenuItem>}
            user={user}
          />
        )}

        <ManageAirAdmin
          user={user}
          trigger={
            <DropdownMenuItem onSelect={(e) => e.preventDefault()}>
              {isAirAdmin(user) ? 'Revoke Air Admin' : 'Promote as Air Admin'}
            </DropdownMenuItem>
          }
        />

        <ManageEdgeCoach
          user={user}
          trigger={
            <DropdownMenuItem onSelect={(e) => e.preventDefault()}>
              {isEdgeCoach(user) ? 'Remove Edge tutors' : 'Add Edge tutors'}
            </DropdownMenuItem>
          }
        />

        {user.edlinkId && (
          <ManualEdlinkSync
            entityType="user"
            internalId={user.id}
            trigger={<DropdownMenuItem onSelect={(e) => e.preventDefault()}>Sync from Edlink</DropdownMenuItem>}
          />
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
